const activationSwitchStyle = (theme) => ({
  '&&': {
    height: '24px !important',
    overflow: 'hidden !important',
    padding: '0 !important',
    width: '42px !important',
  },
  '&& .MuiSwitch-switchBase': {
    margin: '0 !important',
    padding: '2px !important',
    transform: 'translateX(0) !important',
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        backgroundColor: `${theme.palette.primary.accent} !important`,
        color: `${theme.palette.primary.accent} !important`,
      },
      '& + .MuiSwitch-track': {
        backgroundColor: '#9e9e9e !important',
        border: '0 !important',
        opacity: '1 !important',
      },
      transform: 'translateX(18px) !important',
    },
  },
  '&& .MuiSwitch-thumb': {
    backgroundColor: 'gray !important',
    boxShadow: 'none !important',
    boxSizing: 'border-box !important',
    color: 'gray !important',
    height: '20px !important',
    width: '20px !important',
  },
  '&& .MuiSwitch-track': {
    alignSelf: 'center !important',
    backgroundColor: '#9e9e9e !important',
    border: '0 !important',
    borderRadius: '5px !important',
    boxSizing: 'border-box !important',
    height: '10px !important',
    margin: '0 3px !important',
    opacity: '1 !important',
    width: '36px !important',
  },
  '&& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
    opacity: '0.5 !important',
  },
})

export default activationSwitchStyle
